import {
  Card,
  FlexRow,
  IconButton,
  StrokeText,
  absoluteFromDirections,
  colors,
  font,
  fontFamilies,
  fontSizes,
  fullHeight,
  standardSizes,
} from '@toilet-paper-games/ui';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import { PencilFill } from 'react-bootstrap-icons';
import { useControllerAppModel } from '../models/ControllerAppModel';
import { ControllerUserModel } from '../models/ControllerUserModel';

export interface DisplayNameProps {
  user: ControllerUserModel | null;
  className?: string;
  allowNameChange?: boolean;
}

export const DisplayName = observer(
  ({ user, className, allowNameChange }: DisplayNameProps) => {
    const appModel = useControllerAppModel();

    return (
      <Card inset shadow className={className} css={{ padding: standardSizes.md }}>
        <FlexRow
          justifyContent="space-between"
          alignItems="center"
          css={[font(fontFamilies.secondary, fontSizes.md), fullHeight]}
        >
          <StrokeText>{user?.screenName ?? 'Enter Name'}</StrokeText>
          {allowNameChange && (
            <IconButton
              icon={<PencilFill />}
              onClick={action(() => (appModel.uiModel.showEnterNameDialog = true))}
              color={colors.componentInset}
              noIconAnimation
            />
          )}
        </FlexRow>
      </Card>
    );
  },
);
